import { Link } from 'react-router-dom';

const cafeImage =
  'https://readdy.ai/api/search-image?query=Illustration%20of%20a%20cozy%20virtual%20anime%20cafe%20interior%20with%20bookshelves%20full%20of%20manga%2C%20warm%20lantern%20lighting%2C%20cute%20reader%20avatar%20characters%20chatting%20at%20tables%2C%20holographic%20comic%20pages%20floating%20in%20the%20air%2C%20warm%20orange%20and%20amber%20color%20grading%2C%20bold%20clean%20linework%2C%20welcoming%20atmosphere%2C%20clean%20minimal%20background%20with%20warm%20gradient%2C%20high%20quality%20digital%20painting%2C%20no%20text%2C%20no%20watermark&width=1200&height=600&seq=meta-cafe-01&orientation=landscape';

const features = [
  { icon: 'ri-user-smile-fill', title: '读者化身', desc: '创建专属化身，在虚拟空间拥有自己的小圈子' },
  { icon: 'ri-group-fill', title: '组队追更', desc: '与同好组队打卡，追更不再是一个人' },
  { icon: 'ri-cup-line', title: '主题房间', desc: '每晚8点主题分享会，畅聊最新剧情走向' },
];

export default function MetaCafe() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14" aria-label="阅读元宇宙社交">
      <div className="relative overflow-hidden rounded-2xl bg-foreground-950">
        <img
          src={cafeImage}
          alt="57漫画网虚拟漫画咖啡馆概念图"
          title="57漫画网阅读元宇宙虚拟漫画咖啡馆"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/30" aria-hidden="true"></div>
        <div className="relative grid grid-cols-1 gap-8 p-6 md:p-12 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50 md:text-sm">
              <i className="ri-sparkling-2-fill h-4 w-4" aria-hidden="true"></i>
              阅读元宇宙
            </span>
            <h2 className="mt-4 font-display text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              虚拟漫画咖啡馆，
              <br />
              化身交流阅读心得
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-7 text-background-50/85 md:text-base">
              在57漫画网，阅读不止于翻页。走进虚拟漫画咖啡馆，创建你的读者化身，与其他漫友围坐畅聊最新剧情、安利宝藏作品、参与深夜主题分享会。让每一次追更，都成为一场有趣的社交。
            </p>
            <Link
              to="/about"
              className="mt-6 flex w-fit items-center gap-2 whitespace-nowrap rounded-lg bg-background-50 px-6 py-2.5 text-sm font-bold text-foreground-900 transition-colors hover:bg-secondary-100 md:text-base"
            >
              了解元宇宙计划
              <i className="ri-arrow-right-line h-4 w-4" aria-hidden="true"></i>
            </Link>
          </div>
          <div className="flex flex-col justify-center gap-3 md:gap-4">
            {features.map((f) => (
              <div
                key={f.title}
                className="flex items-start gap-3 rounded-lg border border-background-50/15 bg-background-50/10 p-4 backdrop-blur-sm transition-colors hover:bg-background-50/15 md:gap-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className={`${f.icon} h-5 w-5`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="text-sm font-bold text-background-50 md:text-base">{f.title}</h3>
                  <p className="mt-1 text-xs leading-5 text-background-50/75 md:text-sm">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}